import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: ` <app-app> </app-app> `,
})
export class RootComponent {}
